export const ResearchAndFacultyResultsTemplateStyles = (isMobile: boolean) => `

  .research-faculty-tile {
    padding: 15px;
    font-family: var(--lbs-base-font-family), sans-serif;
    color: #001e62;
    display: ${isMobile ? "block" : "flex"};
    flex-direction: column;
    max-width: 400px;
  }

  .research-faculty-image-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  }

  .research-faculty-image-container img {
    width: 100%;
    height: auto;
    transition: transform 0.3s ease;
    max-width: 400px;
    display: block;
  }

  .research-faculty-image-container:hover img {
    transform: scale(1.1);
  }

  .play-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    pointer-events: none;
    text-align: center;

    .img-wrapper,
    img {
      display: inline-block;
      width: 12.81%;
      min-width: 88px;
      max-width: 146px;
    }
  }

  .research-faculty-title {
    margin-bottom: 10px;
    font-size: 1.5625rem;
    max-width: 400px;
  }

  .research-faculty-description {
    margin-bottom: 20px;
    font-size: 1rem;
    max-width: 400px;
  }

  /* Mobile View */
  @media (max-width: 768px) {
    .research-faculty-tile {
      max-width: 100%;
    }
  }
`;
